import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import NoticeDetails from '@/views/NoticeDetails'
import NoticeDetails1 from '@/views/NoticeDetails1'
import NoticeDetails2 from '@/views/NoticeDetails2'
import NoticeDetails3 from '@/views/NoticeDetails3'
import NewsDetails from '@/views/NewsDetails'
import ComingSoon from '@/views/ComingSoon'
import DeclareLogin from '@/views/DeclareLogin'
import ContentList from '@/views/ContentList'
import ContentDetail from '@/views/ContentDetail'

import contestRoutes from '@/contest/router'

Vue.use(Router)

export default new Router({
  routes: [
    ...contestRoutes,
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/noticeDetails',
      name: 'NoticeDetails',
      component: NoticeDetails
    },
    {
      path: '/newsDetails',
      name: 'NewsDetails',
      component: NewsDetails
    },
    {
      path: '/noticeDetails1',
      name: 'NoticeDetails1',
      component: NoticeDetails1
    },
    {
      path: '/noticeDetails2',
      name: 'NoticeDetails2',
      component: NoticeDetails2
    },
    {
      path: '/noticeDetails3',
      name: 'NoticeDetails3',
      component: NoticeDetails3
    },
    {
      path: '/coming-soon',
      name: 'ComingSoon',
      component: ComingSoon
    },
    {
      path: '/declare/login',
      name: 'DeclareLogin',
      component: DeclareLogin
    },
    {
      path: '/content/list',
      name: 'ContentList',
      component: ContentList
    },
    {
      path: '/content/:id',
      name: 'ContentDetail',
      component: ContentDetail
    },
    {
      path: '/partner/:id',
      name: 'PartnerDetail',
      component: () => import('@/views/PartnerDetail.vue')
    },
    {
      path: '/database',
      name: 'Database',
      component: () => import('@/views/Database.vue')
    },
    {
      path: '/database/innovations/:historyId',
      name: 'DatabaseInnovationDetail',
      component: () => import('@/views/DatabaseInnovationDetail.vue')
    },
    {
      path: '/database/thesis/:historyId',
      name: 'DatabaseThesisDetail',
      component: () => import('@/views/DatabaseThesisDetail.vue')
    },
    {
      path: '/expert',
      name: 'ExpertHome',
      component: () => import('@/views/expert/ExpertHome')
    },
    {
      path: '/expert/list',
      name: 'ExpertList',
      component: () => import('@/views/expert/ExpertList')
    },
    {
      path: '/expert/login',
      name: 'ExpertLogin',
      component: () => import('@/views/expert/ExpertLogin')
    },
    {
      path: '/expert/apply',
      name: 'ExpertApply',
      component: () => import('@/views/expert/ExpertApply')
    },
    {
      path: '/expert/my-apply',
      name: 'MyApply',
      component: () => import('@/views/expert/MyApply')
    },
    {
      path: '/expert/success',
      name: 'ApplySuccess',
      component: () => import('@/views/expert/ApplySuccess')
    },
    {
      path: '/expert/settings',
      name: 'ExpertSettings',
      component: () => import('@/views/expert/ExpertSettings')
    },
    {
      path: '/expert/:id',
      name: 'ExpertDetail',
      component: () => import('@/views/expert/ExpertDetail')
    },
    {
      path: '/support/list',
      name: 'SupportList',
      component: () => import('@/views/support/SupportList')
    },
    {
      path: '/support/:id',
      name: 'SupportDetail',
      component: () => import('@/views/support/SupportDetail')
    },
    {
      path: '/about/:slug',
      name: 'AboutDetail',
      component: () => import('@/views/about/AboutDetail')
    },
    {
      path: '/journal',
      name: 'JournalList',
      component: () => import('@/views/journal/JournalList')
    },
    {
      path: '/journal/:id',
      name: 'JournalDetail',
      component: () => import('@/views/journal/JournalDetail')
    },
    {
      path: '/case-center',
      name: 'CaseCenterList',
      component: () => import('@/views/case-center/CaseCenterList')
    },
    {
      path: '/case-center/:id',
      name: 'CaseCenterDetail',
      component: () => import('@/views/case-center/CaseCenterDetail')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js